exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-inner {\n  position: relative;\n  overflow: hidden;\n}\n\n.carousel-item {\n  display: block !important;\n  visibility: hidden;\n  height: 0;\n  opacity: 0;\n  transition: transform 0ms ease-in-out, opacity .6s ease-in;\n  transform: translate3d(0, 0, 0) !important;\n}\n\n.carousel-item.active {\n  opacity: 1;\n  left: auto;\n  height: auto;\n  visibility: visible;\n  transform: translate3d(0, 0, 0) !important;\n}\n\n.carousel-multi-item .carousel-item {\n  display: inline-block !important;\n}\n\n.carousel .carousel-slide-item {\n  transition: left 0.5s;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Carousel.css
// module id = 71
// module chunks = 0